/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-cycle */
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { FormTitle, FormItem } from 'components/shared';
import {
  AutocompleteElement,
  TextFieldElement
} from 'components/muiInputWrappers';
import { AvailableStatus, TicketDetail } from 'api/ticket';
import useHasTicketStatusChangePermission from 'hooks/useHasTicketStatusChangePermission';
import { KEYS } from 'helpers/react-query.config';
import catalog from 'api/catalog';
import { useApiContext } from 'context/ApiContext';
import { AxiosServiceError } from 'interfaces/general';
import { useGlobalContext } from 'context/GlobalContext';
import { AccessElements } from 'helpers/app.config';

export type FormFields = {
  ticketId: number;
  currentStatusId: number;
  newStatusId: number;
  currentStatusName: string;
  delayClassificationId?: number;
};

type Props = {
  ticket: TicketDetail;
  onChangeStatus: (status: AvailableStatus) => void;
};

function StatusChange({ ticket, onChangeStatus }: Props) {
  const { data: ticketStatusOptions, isFetching } =
    useHasTicketStatusChangePermission(ticket?.ticketId);

  const { ticket: ticketApi } = useApiContext();
  const queryClient = useQueryClient();
  const { hasPerm, showSuccess, showApiError } = useGlobalContext();
  const { control, setValue, handleSubmit, resetField } = useForm<FormFields>({
    mode: 'onBlur'
  });

  const { t } = useTranslation('global');

  useEffect(() => {
    setValue('currentStatusId', ticket?.ticketStatusId);
    setValue('currentStatusName', ticket?.ticketStatusName);
    setValue('ticketId', Number(ticket?.ticketId));
    setValue(
      'delayClassificationId',
      Number(ticket?.ticketDelayClassificationId)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticket]);

  const { data: dataDelayClassification } = useQuery(
    [KEYS.catalog.ticketDelayClassification.getAllTicketDelayClassification()],
    () => catalog.ticketDelayClassification.GetAllDelayClassifications(),
    {
      select: (response) => response?.data?.data,
      enabled: !!ticket?.ticketId,
      refetchOnWindowFocus: false
    }
  );

  const updateDelayTicket = useMutation(
    (data: { ticketId: number; ticketDelayClassificationId: number }) =>
      ticketApi.tickets.updateDelayTicket(data),
    {
      onSuccess: async (data) => {
        await queryClient.invalidateQueries(
          KEYS.ticket.tickets.updateDelayTicket(
            Number(data?.data?.data?.ticketId)
          )
        );
        showSuccess(
          t('success.ticketIdUpdated', {
            ticketId: Number(data?.data?.data?.ticketId)
          }),
          3000
        );
      },
      onError: (error: AxiosServiceError) => {
        showApiError(error, t('common.commonMessages.genericRequestError'));
      }
    }
  );

  const onSubmit = (data: FormFields) => {
    const status = ticketStatusOptions?.find(
      (option) => option.id === data.newStatusId
    );

    onChangeStatus(status);
    resetField('newStatusId');
  };

  const selectedClassification = (id: number) => {
    updateDelayTicket.mutate({
      ticketId: ticket?.ticketId,
      ticketDelayClassificationId: id
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid spacing={2} container>
        <Grid
          sx={{
            backgroundColor: ticket?.ticketStatusColor || '#000000',
            width: '14px'
          }}
          item
        />
        <Grid spacing={2} container item xs>
          <Grid
            lg={
              hasPerm([AccessElements.TicketSetDelayClassification]) &&
              ticket?.setDelayClassification
                ? 3
                : 4
            }
            md={
              hasPerm([AccessElements.TicketSetDelayClassification]) &&
              ticket?.setDelayClassification
                ? 3
                : 4
            }
            sm={12}
            xs={12}
            item
          >
            <FormTitle gutterBottom>Ticket</FormTitle>
            <FormItem>
              <TextFieldElement
                control={control}
                name="ticketId"
                size="small"
                variant="outlined"
                disabled
                fullWidth
              />
            </FormItem>
          </Grid>
          <Grid
            lg={
              hasPerm([AccessElements.TicketSetDelayClassification]) &&
              ticket?.setDelayClassification
                ? 3
                : 4
            }
            md={
              hasPerm([AccessElements.TicketSetDelayClassification]) &&
              ticket?.setDelayClassification
                ? 3
                : 4
            }
            sm={12}
            xs={12}
            item
          >
            <FormTitle gutterBottom>
              {t('common.commonProperties.status')}
            </FormTitle>
            <FormItem>
              <TextFieldElement
                control={control}
                name="currentStatusName"
                size="small"
                variant="outlined"
                disabled
                fullWidth
              />
            </FormItem>
          </Grid>
          <Grid
            lg={
              hasPerm([AccessElements.TicketSetDelayClassification]) &&
              ticket?.setDelayClassification
                ? 3
                : 4
            }
            md={
              hasPerm([AccessElements.TicketSetDelayClassification]) &&
              ticket?.setDelayClassification
                ? 3
                : 4
            }
            sm={12}
            xs={12}
            item
          >
            <FormTitle gutterBottom>
              {t('ticket.ticketDetail.nextStatus')}
            </FormTitle>
            <FormItem>
              <AutocompleteElement
                autocompleteProps={{
                  size: 'small',
                  disabled: isFetching || !ticketStatusOptions?.length
                }}
                control={control}
                disabled={isFetching || !ticketStatusOptions?.length}
                name="newStatusId"
                options={
                  ticketStatusOptions?.map((option) => ({
                    id: option?.id,
                    label: option?.name
                  })) || []
                }
                matchId
                required
              />
            </FormItem>
          </Grid>
          {hasPerm([AccessElements.TicketSetDelayClassification]) &&
            ticket?.setDelayClassification && (
              <Grid
                lg={ticket?.setDelayClassification ? 3 : 4}
                md={ticket?.setDelayClassification ? 3 : 4}
                sm={12}
                xs={12}
                item
              >
                <FormTitle gutterBottom>
                  {t('common.commonProperties.delayTicketName')
                    .charAt(0)
                    .toUpperCase() +
                    t('common.commonProperties.delayTicketName').slice(1)}
                </FormTitle>
                <FormItem>
                  <AutocompleteElement
                    autocompleteProps={{
                      size: 'small',
                      disabled: !dataDelayClassification?.length
                    }}
                    control={control}
                    disabled={!dataDelayClassification?.length}
                    handleChange={(_, option) => {
                      selectedClassification(option as unknown as number);
                    }}
                    name="delayClassificationId"
                    options={
                      dataDelayClassification?.map(
                        (option: { id: any; name: any }) => ({
                          id: option?.id,
                          label: option?.name
                        })
                      ) || []
                    }
                    matchId
                  />
                </FormItem>
              </Grid>
            )}
          <Grid
            lg={12}
            md={12}
            sm={12}
            sx={{
              display: 'flex',
              justifyContent: 'end'
            }}
            xs={12}
            item
          >
            <Button
              disabled={isFetching || !ticketStatusOptions?.length}
              size="large"
              sx={{
                backgroundColor: '#1D6FCC',
                color: '#FFF',
                sm: '16px',
                '@media (max-width: 600px)': {
                  width: '100%',
                  marginBottom: '.5em',
                  fontSize: '9px'
                }
              }}
              type="submit"
              variant="contained"
            >
              {t('ticket.ticketDetail.updateStatus')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}

export default StatusChange;
